module.exports = __webpack_public_path__ + "img/dance-video.31d73595.webp";